import { Svg, Path } from 'react-native-svg';

export const Eye = ({ style: { tintColor }, active }: Props) => {
	if (active) {
		return (
			<Svg width="24" height="17" viewBox="0 0 24 17" fill="none">
				<Path
					d="M23 8.5C22 11.5 18.0751 16 12 16C5.92487 16 2 11.5 1 8.5C2 5.5 5.92487 1 12 1C18.0751 1 22 5.5 23 8.5Z"
					stroke={tintColor}
					strokeWidth="1.5"
				/>
				<Path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12 13C14.4853 13 16.5 10.9853 16.5 8.5C16.5 6.01472 14.4853 4 12 4C9.51472 4 7.5 6.01472 7.5 8.5C7.5 10.9853 9.51472 13 12 13ZM12 10C12.8284 10 13.5 9.32843 13.5 8.5C13.5 7.67157 12.8284 7 12 7C11.1716 7 10.5 7.67157 10.5 8.5C10.5 9.32843 11.1716 10 12 10Z"
					fill={tintColor}
				/>
			</Svg>
		);
	}

	return (
		<Svg width="24" height="10" viewBox="0 0 24 10" fill="none">
			<Path
				d="M23 1C22 4 18.0751 8.5 12 8.5C5.92487 8.5 2 4 1 1"
				stroke={tintColor}
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</Svg>
	);
};

type Props = {
	style: {
		tintColor: string;
	};
	active: boolean;
};
